import React from 'react';
import PropTypes from 'prop-types';
import { AppBar, Box, Divider, Icon, IconButton, Typography } from '@material-ui/core';
import { BackBlackIcon } from '../Icons';

const MainHeader = ({
  classes,
  title,
  divider,
  closeIcon,
  onClose,
  children,
  withTabs,
  history,
  search,
  customTitle,
  subtitle,
  titleSize,
  titleWithSearch,
}) => {
  const iconComponent = closeIcon === 'back' ? BackBlackIcon : closeIcon;

  const renderedCustomTitle = customTitle ? customTitle() : null;
  const headerTitleClass = classes[customTitle ? 'customHeaderTitle' : 'headerTitle'];
  const fontSize = titleSize || (closeIcon ? 20 : 32);
  let rootClass = classes.header;
  if (withTabs) {
    rootClass = classes.headerWithTabs;
  } else if (titleWithSearch) {
    rootClass = classes.headerWithTitleAndSearch;
  }

  return (
    <AppBar position="sticky" color="inherit" classes={{ root: rootClass }}>
      <Box className={headerTitleClass} display="flex" alignItems="center" justifyContent="space-between">
        {renderedCustomTitle}
        <Box className={classes.headerBox} display="flex" alignItems="center" flexWrap="nowrap">
          {closeIcon && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="go back"
              data-testid="go-back"
              onClick={onClose || history.goBack}
              classes={{ root: classes.icon }}
            >
              <Icon component={iconComponent} fontSize="small" />
            </IconButton>
          )}
          {search ? (
            search()
          ) : (
            <Box className={classes.title}>
              <Typography style={{ fontSize }} variant="body2" component="div" data-testid="header-title">
                {title}
              </Typography>
              {subtitle && (
                <Typography variant="body2" color="textSecondary" data-testid="header-subtitle">
                  {subtitle}
                </Typography>
              )}
            </Box>
          )}
        </Box>
        <Box display="flex">{children}</Box>
      </Box>
      {divider && <Divider classes={{ root: classes.divider }} variant="middle" />}
    </AppBar>
  );
};

MainHeader.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  /** The title of the MainHeader. */
  title: PropTypes.node,
  /** The subtitle of MainHeader. */
  subtitle: PropTypes.string,
  /** If true, a divider will be shown. */
  divider: PropTypes.bool,
  /** If true, applies specified styles for tabs. */
  withTabs: PropTypes.bool,
  /** If true, applies specified styles for search. */
  titleWithSearch: PropTypes.bool,
  /** The font-size of the title. */
  titleSize: PropTypes.number,
  /** The icon that will be rendered. Either just "back" or Icon. */
  closeIcon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.oneOf(['back'])]),
  /** The content of the MainHeader. */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  /** Render function of cutsomTitle. */
  customTitle: PropTypes.func,
  /** Render function of search. */
  search: PropTypes.func,
  /** Callback if supplied will be called instead of history.goBack */
  onClose: PropTypes.func,
  /** History object from react-router. */
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }),
};

MainHeader.defaultProps = {
  classes: {},
  divider: false,
  withTabs: false,
  titleWithSearch: false,
  search: null,
};

export default MainHeader;
